export default "__VITE_ASSET__125534cb__"